// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"DimensionItemsCell-itemsContainer-14YBof","icon":"DimensionItemsCell-icon-7HEnX_"};